(function(){
  jQuery(document).ready(function ($) {
    if ($('.slider').length) {
      $('.slider').slick({
        slidesToShow: 3,
        arrows: false,
        infinite: true,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1
            }
          }
        ]
      });
  
      $('.slider-wrapper .btn-arrow-left').on('click', function() {
        $('.slider').slick('slickPrev');
      });
  
      $('.slider-wrapper .btn-arrow-right').on('click', function() {
        $('.slider').slick('slickNext');
      });
    }
  });
})();